/* import __COLOCATED_TEMPLATE__ from './icon-radial-progress.hbs'; */
import SvgIcon from './svg-icon';
import { computed } from '@ember/object';
export default SvgIcon.extend({
  classNames: ['svg-icon--radial-progress'],
  classNameBindings: ['isActive:loading-indicator', 'sizeClass'],
  color: 'blue-medium',
  trackColor: 'base',
  size: 'small',
  isActive: false,
  trackColorClass: computed('trackColor', function () {
    if (this.get('trackColor') === 'white') {
      return 'svg-icon--radial-progress__track--theme-color-white';
    } else {
      return 'svg-icon--radial-progress__track--theme-color-base';
    }
  }),
  didReceiveAttrs() {
    this._super();
    if (this.get('size') === 'large') {
      this.setProperties({
        sizeClass: 'svg-icon--radial-progress--large',
        isLarge: true,
        width: 80,
        height: 80,
        viewBox: '0 0 80 80'
      });
    } else {
      this.setProperties({
        sizeClass: 'svg-icon--radial-progress--small',
        isLarge: false,
        width: 20,
        height: 20,
        viewBox: '0 0 20 20'
      });
    }
  }
});